import { ACCESS_TOKEN_NAME, JSON_CONTENT_TYPE } from '../../_constant/constants';
import { CustomerSignUpDto } from '../../_dto/_customer/CustomerSignUpDto';
import { IApiParams } from '../../_interface/IApiParams';
import { getApi } from '../getApi';

export const apiSignUp = async (customerSignUpDto: CustomerSignUpDto) => {
  const params: IApiParams = {
    url: '/customer/signUp.php',
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      'Access-Token': localStorage.getItem(ACCESS_TOKEN_NAME), 
    },
  };
  return getApi(params, 'POST', customerSignUpDto);
};
